import { configureStore } from "@reduxjs/toolkit";

import organizationReducer from "./features/organization-slice";
import branchReducer from "./features/branch-slice";

import userReducer from "./features/user-slice";
import cartReducer from "./features/cart-slice";
import subscriptionReducer from "./features/subscription-slice";

import analyticsReducer from "./features/analytics-slice";
import tourReducer from "./features/tour-slice";
import homeReducer from "./features/home-slice";
import productReducer from "./features/products-slice";

import customerReducer from "./features/customers-slice";
import saleReducer from "./features/sales-slice";
import orderReducer from "./features/orders-slice";

export const store = configureStore({
    reducer : {
        organizationReducer,
        branchReducer,
        userReducer,
        cartReducer,
        subscriptionReducer,
        analyticsReducer,
        tourReducer,
        homeReducer,
        productReducer,
        customerReducer,
        saleReducer,
        orderReducer,
    }
})